import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import BASE_URL from "../config";

function VerifyCertificate() {
  const { id } = useParams(); // URL param
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) {
      setError("Invalid certificate ID");
      setLoading(false);
      return;
    }

    fetch(`${BASE_URL}/api/verify_certificate.php?id=${id}`)
      .then(async (res) => {
        const text = await res.text(); // SAFE read
        try {
          return JSON.parse(text);
        } catch {
          console.error("Non-JSON response:", text);
          throw new Error("Invalid server response");
        }
      })
      .then((res) => {
        if (!res.success) {
          setError(res.error || "Certificate not found");
        } else {
          setData(res.data);
        }
        setLoading(false);
      })
      .catch(() => {
        setError("Server error");
        setLoading(false);
      });
  }, [id]);

  if (loading) return <h2>Verifying certificate...</h2>;
  if (error) return <h2 style={{ color: "red" }}>{error}</h2>;

  return (
    <div style={{ padding: 20 }}>
      <h1>Certificate Verified ✅</h1>

      <p>
        <strong>Student Name:</strong> {data.student_name}
      </p>

      <p>
        <strong>Course:</strong> {data.course}
      </p>

      <p>
        <strong>Issue Date:</strong> {data.issue_date}
      </p>
    </div>
  );
}

export default VerifyCertificate;
